import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { RosterCompensationScreen } from '@/features/hr-reports/roster-compensation-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/roster-compensation')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: RosterCompensationScreenRoute,
})

function RosterCompensationScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <RosterCompensationScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/hr/reports/roster-compensation', search: next })
      }
    />
  )
}
